// Annotation Results Hooks
import { useEffect, useState } from "react"
import * as con from "../Constants"
import { isNullOrUndefined } from "../utils/generalFunctions"

import { RefStoredValue } from "./StoreHooks"



export const RefAnnotationData = () => {

    const data = RefStoredValue(con.ANNOTATION_RESULT_DATA)
    return data
}

/**
 * Reference to the current Annotation result (single query)
 * @returns Object with a the results corresponding to the results of a single query sequence
 */
export const RefSelectedAlignmentResults = () => {

    const [result, setResult] = useState(null)

    const annotationData = RefStoredValue(con.ANNOTATION_RESULT_DATA)
    const selectedQueryId = RefStoredValue(con.SELECTED_ANNOTATION_QUERY_ID)


    useEffect(() => {

        if (!isNullOrUndefined(annotationData) && !isNullOrUndefined(selectedQueryId)) {
            let res = annotationData.find(d => d[con.ARC_QUERY_ID] === selectedQueryId)
            if (!isNullOrUndefined(res))
                setResult(res)
            else
                setResult(null)
        }
        else
            setResult(null)

    }, [annotationData, selectedQueryId])

    return result


}

/**
 * Reference to the selected hit sequence
 * @returns Object with the structure of a hit result
 */
export const RefSelectedAnnotationResultHit = () => {

    const selectedResults = RefSelectedAlignmentResults()
    const selectedResultHitId = RefStoredValue(con.SELECTED_ALIGNMENT_RESULT_HIT_ID)

    const [hit, setHit] = useState(null)


    useEffect(() => {


        if (!isNullOrUndefined(selectedResults) && !isNullOrUndefined(selectedResultHitId)) {
            let res = selectedResults[con.ARC_HITS].find(d => d[con.ARC_SSQID] === selectedResultHitId)
            if (!isNullOrUndefined(res))
                setHit(res)
            else
                setHit(null)
        }
        else
            setHit(null)

    }, [selectedResultHitId, selectedResults])

    return (hit)




}
